// ** Types
import type { Query } from '@/types/graphql';

// ─── Mega-menu body (Strapi Variant 2 — forked components) ───────────────────
// Hand-authored until the `mega-menu` single type lands in graphql.d.ts
// (generated types: ComponentMegaMenuColumn / ComponentMegaMenuLink / MegaMenu).

/** Query root shape for `useGetMegaMenu`. */
export type StrapiMegaMenuQuery = Query;

/** `api::mega-menu.mega-menu` single type body returned by GraphQL. */
export type StrapiMegaMenu = NonNullable<Query['megaMenu']>;

/** Top-level link used in `memberLinks` and inside each column's `items`. */
export type StrapiMegaMenuLink = NonNullable<NonNullable<StrapiMegaMenu['memberLinks']>[number]>;

/** One column in the mega-menu (title + flat list of links). */
export type StrapiMegaMenuColumn = NonNullable<StrapiMegaMenu['columns'][number]>;

/** Reuses the existing `footer.contact` component. */
export type StrapiMegaMenuContact = StrapiMegaMenu['contact'];

/** Reuses the existing `footer.social-link` component. */
export type StrapiMegaMenuSocialLink = NonNullable<NonNullable<StrapiMegaMenu['socialLinks']>[number]>;

// ─── Search (unchanged — still mocked, wired in a later iteration) ───────────

export type StrapiMegaMenuSearchSuggestion = {
	id?: number | string;
	label?: string | null;
};

export type StrapiMegaMenuSearchResult = {
	id?: number | string;
	title?: string | null;
	category?: string | null;
	date?: string | null;
	excerpt?: string | null;
	typeLabel?: string | null;
	imageSrc?: string | null;
	href?: string | null;
};

export type StrapiMegaMenuSearchFilter = {
	value?: string | null;
	label?: string | null;
};
